// import { paginationDataToShow } from "../actions/generalActions";
import {
  USER_CREATE_REQUEST,
  USER_CREATE_SUCCESS,
  USER_CREATE_FAIL,
  ALL_USER_VIEW_REQUEST,
  ALL_USER_VIEW_SUCCESS,
  ALL_USER_VIEW_FAIL,
  ALL_DRIVER_VIEW_REQUEST,
  ALL_DRIVER_VIEW_SUCCESS,
  ALL_DRIVER_VIEW_FAIL,
  CUSTOMERS_BY_ID_SUCCESS,
  ALL_CUSTOMERS_VIEW_REQUEST,
  ALL_CUSTOMERS_VIEW_SUCCESS,
  ALL_CUSTOMERS_VIEW_FAIL,
  ALL_DRIVERS_VIEW_REQUEST,
  ALL_DRIVERS_VIEW_SUCCESS,
  ALL_DRIVERS_VIEW_FAIL,
  USER_AUTH_REQUEST,
  USER_AUTH_SUCCESS,
  USER_AUTH_FAIL,
  USER_LOGOUT_SUCCESS,
  USER_LOGOUT_FAIL,
  USER_UPDATE_REQUEST,
  USER_UPDATE_SUCCESS,
  USER_UPDATE_FAIL,
} from "../constants";

export const userReducer = (
  state = {
    user: {
      user: null,
      driver: null,
      from: null,
      to: null,
      loading: false,
    },
  },
  action
) => {
  switch (action.type) {
    case USER_CREATE_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case USER_CREATE_SUCCESS:
      return {
        ...state,
        loading: false,
      };
    case USER_CREATE_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    // USER VIEW TABLE
    case ALL_DRIVERS_VIEW_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case ALL_DRIVERS_VIEW_SUCCESS:
      return {
        ...state,
        loading: false,
        allDrivers: action.payload,
      };
    case ALL_DRIVERS_VIEW_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    case ALL_CUSTOMERS_VIEW_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case ALL_CUSTOMERS_VIEW_SUCCESS:
      return {
        ...state,
        loading: false,
        allCustomers: action.payload,
      };
    case ALL_CUSTOMERS_VIEW_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    // USER VIEW TABLE
    case ALL_DRIVER_VIEW_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case ALL_DRIVER_VIEW_SUCCESS:
      return {
        ...state,
        loading: false,
        driver: action.payload,
      };
    case ALL_DRIVER_VIEW_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    case CUSTOMERS_BY_ID_SUCCESS:
      return {
        ...state,
        loading: false,
        customerDetails: action.payload,
      };

    // USER UPDATE
    case USER_UPDATE_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case USER_UPDATE_SUCCESS:
      return {
        ...state,
        loading: false,
        // old code hata dya
        user: state.user.map((x) =>
          x.id == action.payload.id ? action.payload : x
        ),
      };
    case USER_UPDATE_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    default:
      return state;
  }
};
